import { render, staticRenderFns } from "./couponMarketList.vue?vue&type=template&id=72d5a13a&scoped=true"
import script from "./couponMarketList.vue?vue&type=script&lang=js"
export * from "./couponMarketList.vue?vue&type=script&lang=js"
import style0 from "./couponMarketList.vue?vue&type=style&index=0&id=72d5a13a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d5a13a",
  null
  
)

export default component.exports